module.exports = __webpack_public_path__ + "static/media/acuvue-cn-qr-code.8928a034.jpg";